import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Select, Space } from 'antd'
import { ThunderboltOutlined } from '@ant-design/icons'

// The steps, grouped as the per-car panel groups them: actions first, then the questions.
export const stepOptions = triggerSteps =>
  [
    {
      label: 'Actions',
      options: (triggerSteps || [])
        .filter(s => s.kind === 'action')
        .map(s => ({ value: s.value, label: s.label }))
    },
    {
      label: 'Ask a question',
      options: (triggerSteps || [])
        .filter(s => s.kind !== 'action')
        .map(s => ({ value: s.value, label: `Ask: ${s.label}` }))
    }
  ].filter(g => g.options.length)

/**
 * "Send a step" for one of the conversation's cars — the same control each car panel has, under
 * the transcript too (owner, 2026-10-29), where an agent decides to nudge the customer.
 *
 * Steps act on a duty CAR, so with several cars the agent picks which; it starts on the active
 * one, which is the car the customer is answering about.
 */
const StepTrigger = ({ cars, triggerSteps, onTrigger, triggeringId, labelFor }) => {
  const active = cars.find(c => c.isActive) || cars[cars.length - 1]
  const [carId, setCarId] = useState(active ? active.id : undefined)
  const [step, setStep] = useState(undefined)

  // A car added or removed since the page loaded must not leave the picker on a car that is gone.
  useEffect(() => {
    if (!cars.find(c => c.id === carId)) setCarId(active ? active.id : undefined)
    // eslint-disable-next-line
  }, [cars])

  const car = cars.find(c => c.id === carId)
  return (
    <Space wrap style={{ width: '100%' }}>
      {cars.length > 1 ? (
        <Select
          value={carId}
          onChange={setCarId}
          style={{ minWidth: 200 }}
          options={cars.map(c => ({
            value: c.id,
            label: labelFor ? labelFor(c) : `Car ${c.position}`
          }))}
        />
      ) : null}
      <Select
        showSearch
        allowClear
        optionFilterProp="label"
        placeholder="Trigger a step"
        style={{ minWidth: 240 }}
        value={step}
        onChange={setStep}
        options={stepOptions(triggerSteps)}
      />
      <Button
        icon={<ThunderboltOutlined />}
        disabled={!step || !car}
        loading={!!car && triggeringId === car.id}
        onClick={() => onTrigger(car, step)}
      >
        Send step
      </Button>
    </Space>
  )
}

StepTrigger.propTypes = {
  cars: PropTypes.array.isRequired,
  triggerSteps: PropTypes.array,
  onTrigger: PropTypes.func.isRequired,
  triggeringId: PropTypes.string,
  labelFor: PropTypes.func
}

export default StepTrigger
